import React, { FC } from "react";
import makeTimelineFromSegment from "../../../store/selectors/timelineFromSegment";
import { UIFlightSegment } from "@flights/types";
import { TimelineSegment } from "./components/TimelineSegment";
import { AmenityProps } from "./components/TimelineLegInfo";
import { useInjectAmenitiesToTimeline } from "../../../hooks/useLegAmenities";

export type Props = {
  segments: UIFlightSegment[];
  hideCabinClassMismatch?: boolean;
} & AmenityProps; // flights_web_route_happy_amenities_ddot, flights_web_route_happy_amenities_mdot

const Timeline: FC<Props> = ({
  segments,
  showAmenities = false,
  amenitiesVariant,
  onAmenitiesPopoverOpen,
  hideCabinClassMismatch
}) => {
  const timelinedSegments = segments.map((segment: UIFlightSegment, segmentIndex: number) => {
    return makeTimelineFromSegment(segment, segmentIndex);
  });

  // Only FD payload has amenities data, while `order.airOrder` is missing it for some reason.
  // So we have to force injecting amenities data from FD here.
  const injectAmenitiesToTimeline = useInjectAmenitiesToTimeline();
  const enrichedSegments = showAmenities ? injectAmenitiesToTimeline(timelinedSegments) : timelinedSegments;

  return (
    <div>
      {enrichedSegments.map((segment, i) => (
        <React.Fragment key={i}>
          <TimelineSegment
            segment={segment}
            segmentIndex={i}
            segmentVariant="fully-visible"
            showAmenities={showAmenities}
            amenitiesVariant={amenitiesVariant}
            onAmenitiesPopoverOpen={onAmenitiesPopoverOpen}
            hideCabinClassMismatch={hideCabinClassMismatch}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default Timeline;
